import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SidebarContent } from './Sidebar';
import { catalogGroupsPage, catalogUsersPage } from './catalogKindPages';

export const navModule = createFrontendModule({
  pluginId: 'app',
  extensions: [SidebarContent, catalogUsersPage, catalogGroupsPage],
});
